import React from 'react';
import IMMasterSubCategory from '../../components/ui/IMMasterSubCategory';
import {
    Row,
    Card,
    CardBody,
   
  } from "reactstrap";

const MasterTable = () => {
  return (
    <div className="page-content">
      <Card>
        <CardBody>
          <div>
            <Row>
              <IMMasterSubCategory serviceId="poNq3omWLHyHDtIlnr7o" />
            </Row>
          </div>
        </CardBody>
      </Card>
    </div>
  )
};

export default  MasterTable;